import { environment } from "src/environments/environment";

export type LoggerType =
  | 'log'
  | 'group'
  | 'warn'
  | 'groupEnd'
  | 'success'
  | 'ignore'
  | 'failed';

export const logger = (type: LoggerType, ...args) => {
  if (environment.production) { return }
  switch (type) {
    case 'log':
      console.log(...args);
      break;
    case 'group':
      console.group(...args);
      break;
    case 'warn':
      console.warn(...args);
      break;
    case 'ignore':
      console.log('➖', ...args);
      break;
    case 'success':
      console.log('✅', ...args);
      break;
    case 'failed':
      console.log('❌', ...args);
      break;
    case 'groupEnd':
      console.groupEnd();
      break;
  }
};
